module.exports = __webpack_public_path__ + "static/media/kk.b1b9dcc8.JPG";